<!--
 * @Author: FengXiao
 * @Date: 2020-07-08 16:47:37
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-09 23:19:16
-->
<template>
  <footer class="bottom-area-base">
    <div class="ting-slogan">
      <img class="ting-slogan-img" src="../assets/imgs/ting-jun-yixi-hua.png" alt="" />
      <!-- <p class="ting-slogan-content">
        {{ tingSloganText }}
      </p> -->
    </div>
    <div class="footer-container">
      <div class="footer-left-bl">
        <div class="footer-list nav-list">
          <h4 class="footer-list-title">一席栏目</h4>
          <div class="link-wrap">
            <router-link
              class="link-item"
              v-for="link in links"
              :key="link.key"
              :to="{ path: `/about/${link.path}`, query: { type: link.type || '' } }"
            >
              {{ link.title }}
            </router-link>
          </div>
        </div>
        <div class="footer-list">
          <h4 class="footer-list-title">关联一席</h4>
          <div class="link-wrap">
			  
            <a class="link-item" v-for="(link, index) in associates" :key="index" :href="link.url" target="_blank">
				<div class="title">{{ link.title }}</div>
				<div class="intro">{{ link.intro }}</div>
              
            </a>
          </div>
        </div>
      </div>
      <div class="footer-qrcode">
		  <div class="footer-qrcode-item">
		    <div class="qrcode-img">
		      <img src="../assets/imgs/qrcode/appDownload.png" alt="" />
		    </div>
		    <p class="qrcode-title">下载一席APP</p>
		  </div>
		  
		  
        <div class="footer-qrcode-item">
          <div class="qrcode-img">
            <img src="../assets/imgs/qrcode/wechat.jpg" alt="" />
          </div>
          <p class="qrcode-title">关注公众号</p>
        </div>
		
        <div class="footer-qrcode-item">
          <div class="qrcode-img">
            <img src="../assets/imgs/qrcode/yixishop.png" alt="" />
          </div>
          <p class="qrcode-title">一席商店</p>
        </div>


        <div class="footer-qrcode-item">
          <div class="qrcode-img">
            <img src="../assets/imgs/yixi_mini.png" alt="" />
          </div>
          <p class="qrcode-title">一席</p>
        </div>
		
      </div>
    </div>
    <div class="copyright">
      <span style="color: #888888;">版权所有：一席话（北京）文化传媒有限公司</span>
      <a href="https://beian.miit.gov.cn" target="_blank" style="margin-left: 20px;">京ICP备13001689号-1</a>
      <a href="" target="_blank" style="margin-left: 20px;">津网文（2023）1294-040号</a>
      <img src="../assets/imgs/beian.png" style="width: 16px; margin-left: 20px;" />
      <a style="color: #888888; margin-left: 10px;" href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502055916" rel="noreferrer"
        target="_blank">京公网安备11010502055916</a>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      tingSloganText:
        '一席是剧场式演讲、结合网络视频传播的平台，2012年成立于北京，已制作“一席·演讲”、“一席·万象”、“一席·枝桠”和“一席·记录”四档视频节目。目前，已有国内外近千位讲者和表演嘉宾登上一席的舞台，网络视频播放量已超过15亿次。',
      links: [
        { title: '关于一席', path: 'aboutYiXi' },
        { title: '商务合作', path: 'businessCooperation' },
        { title: '版权说明', path: 'copyright' },
      ],
      associates: [
        { title: '微博：', intro: '@一席YiXi', url: 'https://weibo.com/yixiclub' },
        { title: '豆瓣：', intro: '@一席', url: 'https://www.douban.com/people/190512896/?_i=1138089xFkK0Kc' },
        { title: '喜马拉雅：', intro: '@一席', url: 'https://www.ximalaya.com/zhubo/7418817' },
        { title: '播客：', intro: '@一席YiXi', url: 'https://podcasts.apple.com/cn/podcast/%E4%B8%80%E5%B8%ADyixi/id676106704' },
        { title: 'bilibili：', intro: '@一席精选', url: 'https://space.bilibili.com/26079128' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.bottom-area-base {
  background-color: $C1;
  background-size: 100% 3px;

  .ting-slogan {
    background: $C1;
    padding: 80px 0;

    //border-bottom: 2px dotted rgba(206, 10, 0, 0.5);
    &-img {
      display: block;
      width: 200px;
      height: 100px;
      margin: 0 auto;
      object-fit: contain;
    }

    &-content {
      width: 392px;
      line-height: 1.6;
      color: $C6;
      font-size: 14px;
      font-weight: 300;
      text-align: center;
      margin: 0 auto;
    }
  }

  .footer-container {
    max-width: 1140px;
    width: 80%;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .footer-left-bl {
      display: flex;
      align-items: flex-start;
    }

    .footer-list {
      margin-right: 50px;
      display: inline-block;

      &-title {
        font-size: 12px;
        color: $C2;
        font-weight: 400;
        margin-top: 5px;
      }

      .link-wrap {
        width: 240px;

        .link-item {

          .title,
          .intro {
            display: inline-block;
          }

          .intro {

            // color: rgba(248,91,91,0.59);
            &:hover {
              color: $C2;
            }
          }

          padding: 5px 0;
          display: inline-block;
          font-size: 12px;
          color: $C6;
          line-height: 1.5;
          font-weight: 300;
          width: 50%;
          outline: none;
          text-decoration: none;
          // display: flex;

        }
      }

      // 一席栏目：链接单列展示，压缩左侧宽度，为右侧二维码腾出空间
      &.nav-list {
        .link-wrap {
          width: auto;

          .link-item {
            display: block;
            width: auto;
          }
        }
      }
    }

    .footer-qrcode {
      display: flex;
      flex-shrink: 0;

      &-item {
        text-align: center;
        display: inline-block;
        margin-right: 10px;
        padding: 10px 10px 0 10px;
        box-sizing: border-box;
        width: 130px;
        height: 142px;
        background: $C1;
        border: 1px solid $C11;
        border-radius: 5px;

        .qrcode-img {
          width: 110px;
          height: 110px;
          display: block;
          border-radius: 2px;

          &>img {
            width: 100%;
            height: 100%;
            max-width: 100%;
            vertical-align: bottom;
          }
        }

        .qrcode-title {
          font-size: 12px;
          color: $C4;
          margin: 0;
          font-weight: 300;
          // margin-top: -5px;
        }
      }
    }
  }

  .copyright {
    font-size: 12px;
    color: $C9;
    background: $C6;
    padding: 20px 0;
    text-align: center;

    &>a {
      color: $C9;
      text-decoration: none;
    }

  }
  .company {
    font-size: 12px;
    color: $C9;
    background: $C6;
    padding: 0 0 20px 0;
    text-align: center;

    &>a {
      color: $C9;
      text-decoration: none;
    }

  }
}
</style>
